<template id="Central__App">
    <section class="central-background">
        <LevelTwo :router="router" />
        <main class="page-content px-0 position-relative">
            <router-view />
        </main>
    </section>
</template>

<script lang="ts" src="./CentralApp.ts"></script>
